import store from '@/store';

/*
 * Vue 컴포넌트가 아닌 곳에서 store에 직접 접근하지 않도록
 * */
export const throwLoadingSpinner = function(showing: boolean) {
  store.commit('SET_SHOWING_LOADING_SPINNER', showing);
};
